import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer>
      <p>&copy; 2025 BallotVision. Capstone Project.</p>
      <p>
        <a href="https://github.com/CodeBusters-Wordle-Crackdown/Team-Code-Busters-2.0/" target="_blank" rel="noopener noreferrer">Team Code Busters </a>
      </p>
    </footer>
  );
};

export default Footer;